import React from 'react'
import ContentLoading from 'components/ContentLoading'
import FirmDashboardJobsViewModel from './FirmDashboardJobTableViewModel'
import ContentError from 'components/ContentError'
import FirmDashboardJobsTable from '../FirmDashboardJobsTable'
import { useActivation } from 'hooks/mobx-hooks'
import { observer } from 'mobx-react'
import styles from './FirmDashboardJobsViewer.sass'
import { useOnEscDown } from 'hooks/key-press'

interface FirmDashboardJobsViewerProps {
  vm: FirmDashboardJobsViewModel
}

export default observer(function FirmDashboardJobsViewer({
  vm,
}: FirmDashboardJobsViewerProps) {
  useActivation(vm)
  useOnEscDown(vm.searcher.searchText.clear)

  return (
    <div>
      {vm.activate.match({
        pending: () => <ContentLoading />,
        rejected: (err) => <ContentError error={err} />,
        resolved: () => <FirmDashboardJobsTable vm={vm} />,
      })}
    </div>
  )
})

export const FirmDashboardJobCount = observer(function JobCount({
  vm,
}: FirmDashboardJobsViewerProps) {
  const totalJobs = vm.searcher.totalJobs

  return (
    <div className={styles.jobCountContainer}>
      Jobs
      <span className={styles.resultCount}>({totalJobs ?? 0})</span>
    </div>
  )
})
